<template>
  <div>
    <v-row>
      <v-col>
        <h2>{{ pageTitle }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col cols="12" align="center">
              <v-text-field
                label="Название тэга"
                v-model="tag.name"
                required
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <v-text-field
                label="Наименование меты(СЕО)"
                v-model="tag.metaTitle"
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <v-text-field
                label="Описание меты(СЕО)"
                v-model="tag.metaDescription"
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center"
              ><v-autocomplete
                :items="categories"
                item-title="text"
                item-value="value"
                label="Выберите категорию"
                v-model="tag.categoryId"
              ></v-autocomplete
            ></v-col>
            <v-col cols="12" align="center"
              ><v-autocomplete
                :items="subcategories"
                item-title="text"
                item-value="value"
                label="Выберите подкатегории"
                v-model="tag.subcategories"
              ></v-autocomplete
            ></v-col>
            <v-col cols="12">
              <h2>Фильтр</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list>
                <v-list-group
                  v-for="prop in filter.propertyList"
                  :key="prop.id"
                  :title="prop.name"
                >
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" :title="prop.name">
                    </v-list-item>
                  </template>
                  <v-list-item>
                    <div v-if="prop.isRange">
                      <v-range-slider
                        step="1"
                        :min="prop.minValue"
                        :max="prop.maxValue"
                        v-model="priceFilter"
                        @update:modelValue="hh($event, prop)"
                      ></v-range-slider>
                      <v-row justify="space-between">
                        <v-col cols="1">{{ prop.minValueClient > 0 ? prop.minValueClient : prop.minValue }}</v-col>
                        <v-col cols="1">{{ prop.maxValueClient > 0 ? prop.maxValueClient : prop.maxValue }}</v-col>
                      </v-row>
                    </div>
                    <div v-else>
                      <div v-for="(val, index) in prop.list" :key="index">
                        <v-checkbox
                          :label="val.value"
                          v-model="val.selected"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" @click="update()"> Сохранить </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const CategoriesRepository = RepositoryFactory.get("category");
const SubcategoriesRepository = RepositoryFactory.get("subCategory");
const SubcategoryTagRepository = RepositoryFactory.get("subcategoryTag");
export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      tag: {
        id: 0,
        name: "Новый тэг",
        categoryId: null,
        subcategories: null,
        metaTitle: null,
        metaDescription: null,
      },
      nameRules: [
        (value) => {
          if (value) return true;

          return "Поле обязательно для заполнения.";
        },
      ],
      categories: [],
      subcategories: [],
      filter: {},
      priceFilter: [],
      isEntityLoading: false,
    };
  },
  watch: {
    "tag.categoryId": function (newVal, oldVal) {
      if (newVal != oldVal && newVal > 0 && !this.isEntityLoading) {
        console.log(this.isEntityLoading)
        this.getSubcategories(newVal);
      }
    },
    "tag.subcategories": function (newVal, oldVal) {
      if (newVal != oldVal && newVal > 0 && !this.isEntityLoading) {
        this.getSubcategoryFilter(newVal);
      }
    },
  },

  mounted() {
    this.getCategories();
    this.get();
  },
  methods: {
    async getCategories() {
      const result = await CategoriesRepository.getCategoriesForSelect();
      if (result.data.status === "success") {
        this.categories = result.data.data;
      }
    },
    async getSubcategories(categoryId) {
      const result =
        await SubcategoriesRepository.getCategoriesByCategoryForSelect(
          categoryId
        );
      if (result.data.status === "success") {
        this.subcategories = result.data.data;
      }
    },
    async getSubcategoryFilter(categoryId) {
      const result = await SubcategoriesRepository.getSubcategoryFilter(
        categoryId
      );
      if (result.data.status === "success") {
        this.filter = result.data.data;
      }
    },
    async create() {
      this.isLoading = true;
      const propes = await this.getFilterProps();
      const range = await this.getRange();

      const formData = new FormData();

      const filter = await this.encodeFilter(range, propes)

      var data = {
        name: this.tag.name,
        tagCode: filter,
        subcategoryId: this.tag.subcategories,
        categoryId: this.tag.categoryId,
        metaTitle: this.tag.metaTitle,
        metaDescription: this.tag.metaDescription,
      }

      const result = await SubcategoryTagRepository.create(data);
      if (result.data.status === "success") {
        this.tag = result.data.data;
        this.$router.replace({
          path: "/subcategory-tags",
        });
      }
    },
    async update() {
      if (this.tag.id > 0) {
        this.isLoading = true;

        const propes = await this.getFilterProps();
        const range = await this.getRange();
        const filter = await this.encodeFilter(range, propes)
        var data = {
          name: this.tag.name,
          tagCode: filter,
          subcategoryId: this.tag.subcategories,
          categoryId: this.tag.categoryId,
          metaTitle: this.tag.metaTitle,
          metaDescription: this.tag.metaDescription,
        }

        const result = await SubcategoryTagRepository.update(this.tag.id, data);

        this.isLoading = false;
      } else {
        await this.create();
      }
    },
    getFilterProps() {
      const dataProps = [];
      this.filter.propertyList.forEach((element) => {
        const dataVal = [];
        let i = 0;
        var propObj = {
          p: element.id,
          l: [],
        };
        element.list.forEach((val) => {
          if (val.selected) {
            dataVal.push({ v: val.value });
            i++;
          }
        });
        if (i > 0) {
          propObj.l = dataVal;
          dataProps.push(propObj);
        }
      });
      return dataProps;
    },
    getRange() {
        var dataRange = [];
        this.filter.propertyList.forEach((element) => {
          if(element.isRange){
            const minValue = element.minValueClient;
            const maxValue = element.maxValueClient;

            var propObj = {
              p: element.id,
              l: []
            };

            const item = {
              n: minValue,
              m: maxValue
            }

            propObj.l = item;
            dataRange.push(propObj);
          }
        });
        return dataRange.length === 0 ? null : dataRange;
    },
    async encodeFilter(range, filter) {
      var data = {
        f: filter, // фильтры
        r: []
      };

      if(range){
        data.r = range;
      }

      // убираем пустые
      /*for (var x in data) {
        if (data.hasOwnProperty(x)) {
          var y = data[x];
          if (!y) delete data[x];
        }
      }*/

      data = JSON.stringify(data);

      return data ? window.btoa(unescape(encodeURIComponent(data))) : "";
    },
    hh(val, prop){
      prop.minValueClient = val[0];
      prop.maxValueClient = val[1];
    },
    async get() {
      if (this.$route.params.id > 0) {
        this.isEntityLoading = true;
        const result = await SubcategoryTagRepository.get(this.$route.params.id);
        if (result) {
          if (result.data.status === "success") {
            this.tag.id = result.data.data.id;
            this.tag.categoryId = result.data.data.categoryId;
            await this.getSubcategories(this.tag.categoryId);
            this.tag.subcategories = result.data.data.subcategoryId;
            this.tag.name = result.data.data.name;
            this.tag.metaTitle = result.data.data.metaTitle;
            this.tag.metaDescription = result.data.data.metaDescription;
            
            this.filter = result.data.data.filter;
            this.$nextTick(() => {
              this.isEntityLoading = false;
            });
            
           //
          }
          
        }
      }
    },
  },
};
</script>
